<template>
  <div class="my-3">
    <label>Edit Active Programs</label>
    <div class="row p-3">
      <div class="col-sm-12 col-md-12 col-lg-12 border p-3">
        <div
          v-for="program in getClientPrograms"
          :key="program.programId"
          class=""
        >
          <div v-if="program.active === true">
            <router-link
              :to="{
                name: 'AdminPointProgramsEditProgramContest',
                params: { programId: program.programId },
              }"
              @click.native="scrollToTop"
              class="my-2"
              >{{ program.programName }}</router-link
            >
            <br />
            <p
              class="m-2"
              v-for="client in program.associatedClients"
              :key="client.associated_ClientId"
            >
              {{ client.associated_ClientName }}&nbsp;
            </p>
            <hr />
          </div>
        </div>
      </div>
    </div>
    <label>Inactive Programs/contests</label>
    <div class="row p-3">
      <div class="col-sm-12 col-md-12 col-lg-12 border p-3">
        <div
          v-for="program in getClientPrograms"
          :key="program.programId"
        >
          <div v-if="program.active === false">
            <router-link
              :to="{
                name: 'AdminPointProgramsEditProgramContest',
                params: { programId: program.programId },
              }"
              @click.native="scrollToTop"
              class="my-2"
              >{{ program.programName }}</router-link
            >
            <br />
            <p
              class="m-2"
              v-for="client in program.associatedClients"
              :key="client.associated_ClientId"
            >
              {{ client.associated_ClientName }}&nbsp;
            </p>
            <hr />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PointProgramsList",

  data() {
    return {};
  },

  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

  computed: {
    getUserClients() {
      return this.$store.getters["user/getUserClients"];
    },
    getClientPrograms() {
      return this.$store.getters["adminPointPrograms/getClientPrograms"];
    },
  },

  watch: {},

  created() {
    this.scrollToTop();
    this.$store.dispatch("adminPointPrograms/fetchProgrammes", {
      clientId: 0,
    });
  },
};
</script>

<style lang="scss" scoped>
</style>
